/**
 * Forces reflow of context and resets css animation
 */
/* eslint-disable no-param-reassign */
export default function forceRerenderCssAnimation(el: HTMLElement) {
  const initialStyleAnimation = el.style.animation;
  el.style.animation = "none";
  /** Forces browser to rerender */
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  el.offsetHeight;
  el.style.animation =
    initialStyleAnimation !== null ? initialStyleAnimation : null;
}
